import React, { useState, useEffect  } from 'react';
import './Apple.css';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { CloudfrontVideoFormat } from '../../../videos/CloudfrontVideoFormat';

/**
 * Plays the celebrate video module shown at the end of each day
 * @param {*} props
 * @returns the HTML code for the celebrate module
 */
export default function AppleLearn(props) {
  // Initialize variables to be used later

  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const dispatch = useDispatch();
  const [apples, setApples] = useState(true);
  const [apple1, setApple1] = useState(true);
  const [apple2, setApple2] = useState(false);
  const [apple3, setApple3] = useState(false);
  const [effect1, setEffect1] = useState('bounceIcons');
  const [effect2, setEffect2] = useState('');
  const [effect3, setEffect3] = useState('');
  const [displayLearnVideo, setDisplayLearnVideo] = useState(false);
  const [appleNum, setAppleNum] = useState(0);
  const [learnVideo, setlearnVideo] = useState('');
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const Tree = generateImageUrl('images/Module15Images/Tree.png');
  const bounceSound = new Audio(generateImageUrl('media/Module1Videos/button_bouncing.mp3'));
  const touchSound = new Audio(generateImageUrl('media/Module1Videos/touch_button.mp3'));
  const apple1Img = generateImageUrl('images/Module20Images/U4_M5_Apple1.svg');
  const apple2Img = generateImageUrl('images/Module20Images/U4_M5_Apple2.svg');
  const apple3Img = generateImageUrl('images/Module20Images/U4_M5_Apple3.svg');
  const [Exit, setExit] = useState(generateImageUrl('images/Images/close.png'));

  // CSS code for the back button


  const displayVideo = (video, num) => {
    setlearnVideo(video);
    setAppleNum(num);
    setApples(false);
    setDisplayLearnVideo(true);
  };

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  useEffect(() => {
    sleep(700).then(() => {
      bounceSound.play()
    });
  }, []);

  // The actual HTML code that determines whether to show the module above.
  return (
    <>
      <div
        className='appleScene'
        style={{ backgroundImage: `url(${props.background})` }}
      >
        <img
          className='back-btn-ftb'
          src={Exit}
          onClick={() => {
            props.setDisplayLearn(false);
          }}
        ></img>
        {displayLearnVideo && (
          <CloudfrontVideoFormat
            source={learnVideo}
            back={'unit4'}
            background={props.background}
            close={()=>{setDisplayLearnVideo(false); setApples(true);}}
            ended={() => {
              setDisplayLearnVideo(false);
              setApples(true);
              if (appleNum === 1) {
                setEffect1('');
                setEffect2('bounceIcons');
                setApple2(true);
                sleep(700).then(() => {
                bounceSound.play()
                });
              } else if (appleNum === 2) {
                setEffect2('');
                setEffect3('bounceIcons');
                setApple3(true);
                sleep(700).then(() => {
                bounceSound.play()
                });
              } else if (appleNum === 3) {
                if (props.module.reviewIcon === false) {
                  dispatch({ type: props.step_completed, payload: 'learn' });
                }
                props.module.sectionCompleted = props.module.sectionCompleted + 1
                props.setDisplayLearn(false);
              }
            }}
          />
        )}
        <img className='appleTree' src={Tree} ></img>
        {apples && (
          <div className='bird_apple'>
            {apple1 && (
              <div
                className='apple1'
                onClick={() => {
                  touchSound.play()
                    sleep(500).then(() => {
                    displayVideo(props.learnVideo1, 1);
                  });
                }}
              >
                <img alt='' className='apple1' id={effect1} src={apple1Img} />
              </div>
            )}
            {apple2 && (
              <div
                className='apple2'
                onClick={() => {
                  touchSound.play()
                    sleep(500).then(() => {
                    displayVideo(props.learnVideo2, 2);
                  });
                }}
              >
                <img alt='' className='apple2' id={effect2} src={apple2Img} />
              </div>
            )}
            {apple3 && (
              <div
                className='apple3'
                onClick={() => {
                  touchSound.play()
                    sleep(500).then(() => {
                    displayVideo(props.learnVideo3, 3);
                  });
                }}
              >
                <img alt='' className='apple3' id={effect3} src={apple3Img} />
              </div>
            )}
            {/* {<img alt='' className='module20Bird' src={props.animal} />} */}
          </div>
        )}
      </div>
    </>
  );
}
